import React from 'react';
import { TravelTimeDisplay } from '../components/Grid/ActivityCommon';
import { Location } from '../components/Icons/CustomIcons';

export const AddressField = ({ address, showTravelTime = false, travelLoading, travelError, travelTime, atDestination = false, headerActions }) => {
  const commaIndex = address ? address.indexOf(',') : -1;
  const street = commaIndex !== -1 ? address.slice(0, commaIndex).trim() : address;
  const cityLine = commaIndex !== -1 ? address.slice(commaIndex + 1).trim() : null;

  return (
    <div className="activity-detail-address">
      <div className="activity-detail-address-link">
        <div className="activity-detail-address-header">
          <h2 className="card-header">Adresse</h2>
          <p className="card-subtitle">{showTravelTime ? 'Wie Sie dorthin kommen' : 'Wohin es geht'}</p>
        </div>
        {headerActions}
      </div>
      <div className="activity-detail-location-box">
        <div className="activity-detail-location-icon">
          {!showTravelTime && (
            <div className="timeline-icon">
              <Location size={20} />
            </div>
          )}
          <span className="card-address">
            <span className="card-address-span">{street} </span>
            {cityLine && <span className="card-address-span" style={{ whiteSpace: 'nowrap' }}>{cityLine}</span>}
          </span>
          
        </div>
        {!showTravelTime && (
          <span className="body Font-S-B-130-T Colors-Grey-06 location-label">Adresse der Aktivität</span>
        )}
        {showTravelTime && (
          <TravelTimeDisplay
            travelLoading={travelLoading}
            travelError={travelError}
            travelTime={travelTime}
            atDestination={atDestination}
          />
        )}
      </div>
    </div>
  );
};
